<div class="main-container">
  <h2 class="ml-4 mt-4">Radicación de Traslados</h2>
  <mat-stepper #stepper [orientation]="(stepperOrientation | async)!">
    <mat-step [stepControl]="frmConsult" label="Consultar usuarios"> </mat-step>

    <mat-step label="Seleccionar tipo de novedad"> </mat-step>

    <mat-step label="Realizar perfilamiento de la novedad"> </mat-step>

    <mat-step label="Validar Auditoría"> </mat-step>

    <mat-step label="Radicar solicitud"> </mat-step>
  </mat-stepper>
  <div>
    <div class="px-4">
      <app-info-alert
        [title]="'Ingrese la información del usuario a consultar'"
      >
        Recuerde que puede hacer la búsqueda por tipo y número de documento, por
        número de contrato o por ambos.
      </app-info-alert>
    </div>
    <div class="radicacion-traslados-content no-padding-hints row">
      <form
        class="consult-form"
        [formGroup]="frmConsult"
        (ngSubmit)="onSubmit()"
      >
        <div class="form-container row">
          <div class="col-12">
            <div class="row">
              <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 form-item">
                <mat-form-field style="width: 100%">
                  <mat-label>Tipo de Identificación</mat-label>
                  <mat-select name="docItem" formControlName="documentType">
                    @for (docItem of tiposDocumento; track docItem) {
                      <mat-option [value]="docItem.codigo">
                        {{ docItem.codigo }} - {{ docItem.tipo_documento }}
                      </mat-option>
                    }
                  </mat-select>
                  <mat-error
                    *ngIf="getControl['documentType'].hasError('required')"
                  >
                    El campo es obligatorio.
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 form-item">
                <mat-form-field style="width: 100%">
                  <mat-label>Número de Identificación</mat-label>
                  <input
                    matInput
                    type="text"
                    (keydown)="allowOnlyNumbers($event)"
                    formControlName="documentNumber"
                    (keydown)="disableArrowKeys($event)"
                  />
                  <mat-error
                    *ngIf="getControl['documentNumber'].hasError('required')"
                  >
                    El campo es obligatorio.
                  </mat-error>
                  <mat-error
                    *ngIf="getControl['documentNumber'].hasError('maxlength')"
                  >
                    Máximo 30 dígitos permitidos.
                  </mat-error>
                  <mat-error
                    *ngIf="getControl['documentNumber'].hasError('minlength')"
                  >
                    Mínimo 5 dígitos permitidos.
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 form-item">
                <mat-form-field style="width: 100%">
                  <mat-label>Número de contrato</mat-label>
                  <input
                    matInput
                    type="text"
                    (keydown)="allowOnlyNumbers($event)"
                    formControlName="contractNumber"
                    (keydown)="disableArrowKeys($event)"
                  />
                  <mat-error
                    *ngIf="getControl['contractNumber'].hasError('required')"
                  >
                    El campo es obligatorio.
                  </mat-error>
                </mat-form-field>
              </div>
              <div
                class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 form-item mb-3"
              >
                <div
                  [ngbTooltip]="
                    frmConsult.invalid
                      ? 'Debe ingresar al menos un criterio de consulta: identificación del usuario o número de contrato'
                      : 'Se obtiene solo los contratos en estado activo'
                  "
                  tooltipClass="tooltip-custom"
                  [placement]="tooltipPlacement"
                >
                  <button
                    type="submit"
                    [disabled]="frmConsult.invalid || isSubmitting"
                    class="btn btn-primary btn-icon w-100"
                  >
                    <span>Consultar</span>
                  </button>
                </div>
              </div>
              <div
                class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 form-item mb-3"
              >
                <button
                  type="button"
                  [disabled]="!hayEstadoParaLimpiar()"
                  class="btn btn-outline-primary btn-icon w-100"
                  (click)="onReset()"
                >
                  <span>Limpiar</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
      <ng-template #tmplVerContratos let-readonly="readonly">
        <app-info-alert title="Contratos activos">
          <div class="d-flex align-items-center flex-wrap gap-2">
            Seleccione el botón
            <mat-icon>remove_red_eye</mat-icon> para visualizar el detalle del
            contrato
          </div>
          <div class="d-flex align-items-center flex-wrap gap-2">
            Seleccione el botón
            <mat-icon>article</mat-icon> para visualizar el histórico de
            traslados que ha tenido el contrato
          </div>
        </app-info-alert>

        <div class="row g-3 m-4 justify-content-start">
          <div class="m-0">
            <div class="text-bold">Cantidad de contratos activos:</div>
            {{ contratosData.length }}
          </div>
          <div
            class="col-12 col-md-6 col-lg-4"
            *ngFor="let contrato of contratosData"
          >
            <app-contrato-card
              [readonly]="readonly"
              [contrato]="contrato"
              (viewDetails)="onViewContractDetails($event)"
            ></app-contrato-card>
          </div>
        </div>
      </ng-template>
      <ng-template #tmplVerDetallesContrato let-readonly="readonly">
        <app-info-alert title="Detalles del contrato">
          Seleccione los integrantes a los que aplicará la novedad de traslado
        </app-info-alert>
        <div
          *ngIf="isLoadingValidacion"
          class="d-flex flex-column justify-content-center align-items-center p-5 gap-3"
        >
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
          </div>
          <span class="ms-2 text-muted"
            >Cargando integrantes del contrato...</span
          >
        </div>

        <!-- Error con reintento -->
        <div
          *ngIf="errorLoadingContrato && !isLoadingValidacion"
          class="d-flex align-items-center gap-2 mx-4 my-3 px-3 py-3"
          style="
            border: 1px solid #b0c4de;
            border-radius: 6px;
            background: #f0f6ff;
            color: #1a3a5c;
          "
        >
          <mat-icon style="color: #1a6cbe; flex-shrink: 0">info</mat-icon>
          <span style="flex: 1; font-size: 0.92rem">
            Ocurrió un error inesperado, pulse el botón para reintentar la
            consulta, si la falla persiste, contacte al equipo de soporte.
          </span>
          <button
            type="button"
            class="btn btn-link p-0 ms-2"
            (click)="retryLoadContractDetails()"
            [ngbTooltip]="'Reintentar'"
            style="color: #1a6cbe"
          >
            <mat-icon>refresh</mat-icon>
          </button>
        </div>

        <div class="p-4" *ngIf="!errorLoadingContrato && !isLoadingValidacion">
          <app-table-novedad-traslados
            [readonly]="readonly"
            (selectionChange)="onSelectionChange($event)"
            (rowsSelected)="onRowsSelected($event)"
            [preselectedRows]="selectedContractUsers"
            [data]="validacionTablaData"
          >
          </app-table-novedad-traslados>
          <div style="width: 14% !important">
            <div
              [ngbTooltip]="
                hasSelectionNovedadTraslados
                  ? 'Continúa al segundo paso para seleccionar el tipo de novedad que aplicará a cada integrante del contrato seleccionado.'
                  : ''
              "
              tooltipClass="tooltip-custom"
              [placement]="tooltipPlacement"
            >
              <button
                class="btn btn-primary btn-icon w-80 mt-4"
                [disabled]="readonly || !hasSelectionNovedadTraslados || !sarlaftCoincidenciaValida"
                (click)="goToSecondStep()"
              >
                <span>Siguiente</span>
              </button>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #tmplSeleccionarTipoNovedad let-readonly="readonly">
        <app-info-alert title="Tipo de novedad">
          Seleccione el tipo de novedad de traslado que corresponda a la
          solicitud y dilgencie los campos requeridos para el tipo seleccionado
        </app-info-alert>
        <div style="padding: 2rem">
          <app-tipo-novedad-selector
            #tipoNovedadSelector
            [readonly]="readonly"
            [contratoSeleccionado]="contratoSeleccionado"
            [numeroContratoPaso1]="selectedContract"
            [filaContratoAfilmedPaso1]="filaContratoAfilmedPaso1"
            [integrantesSeleccionados]="integrantesSeleccionados"
            [integrantesTotalesContratoActual]="validacionTablaData"
            (tipoNovedadSeleccionada)="onTipoNovedadSeleccionada($event)"
            (subtipoNovedadSeleccionada)="onSubtipoNovedadSeleccionada($event)"
            (validacionCompletada)="onValidacionCompletada($event)"
            (integrantesActualizados)="onIntegrantesActualizados($event)"
            [integrantesSeleccionadosPaso1]="integrantesSeleccionadosPaso1"
            (contratoPaso1Actualizado)="onContratoPaso1Actualizado($event)"
          >
          </app-tipo-novedad-selector>
          <div style="width: 20% !important">
            <div
              [matTooltip]="
                validacionTipoNovedadCompleta
                  ? 'Continúa al tercer paso para realizar el perfilamiento de la novedad.'
                  : 'Debe completar la selección del tipo de novedad antes de continuar'
              "
            >
              <button
                class="btn btn-primary btn-icon w-80 mt-4"
                [disabled]="readonly ||!validacionTipoNovedadCompleta"
                (mousedown)="onAntesSiguienteTipoNovedad()"
                (click)="goToThirdStep()"
              >
                <span>Siguiente</span>
              </button>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #tmplRealizarPerfilamientoNovedad let-readonly="readonly">
        <div
          *ngIf="isLoadingCuestionario"
          class="d-flex flex-column justify-content-center align-items-center p-5 gap-3"
        >
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
          </div>
          <span class="text-muted">Procesando perfilamiento...</span>
        </div>

        <ng-container *ngIf="!isLoadingCuestionario">
          <app-info-alert title="Resultado del perfilamiento">
            Observe el resultado obtenido. Solo se habilitará el siguiente paso
            para los integrantes que cumplan con los criterios definidos en el
            perfilamiento.
          </app-info-alert>

          <div class="perfilamiento-container">
            <app-alert-message
              type="success"
              message="CUMPLE perfilamiento"
            ></app-alert-message>
            <div class="p-4">
              <app-table
                [attrData]="attrDataPerfilamiento"
                [namesColumns]="namesColumnsPerfilamiento"
                [data]="cumplePerfilamiento"
              ></app-table>
            </div>
            <app-info-alert title="Declaración Estado de Salud">
              Responda a las preguntas de salud por cada uno de los integrantes
              que cumplen el perfilamiento
            </app-info-alert>
            <div
              class="row g-3 m-4 justify-content-start"
              *ngIf="mostrarCuestionariosSalud"
            >
              <div
                *ngFor="let usuario of cuestionarioSaludUsuarios; let i = index"
                class="col-12 col-md-6 col-lg-6"
              >
                <app-cuestionario-salud-card
                  [readonly]="readonly"
                  [nombrePersona]="usuario?.nombreUsuario || ''"
                  [usuario]="usuario"
                  [storageKey]="'healthQuest_' + i"
                  (errorCuestionario)="abrirModalErrorCuestionarioSalud($event)"
                  #cardRef
                ></app-cuestionario-salud-card>
              </div>
            </div>
            <div class="px-4 pb-4">
              <ng-template #modalContent>
                <div class="modal-header-content">
                  <mat-icon>help</mat-icon>
                  <p>
                    ¿Desea iniciar el proceso de validación para determinar si
                    los siguientes integrantes que cumplieron el perfilamiento
                    requieren evaluación de auditoría?
                  </p>
                </div>
                <ng-container *ngIf="mostrarTablaCumplePerfilamiento">
                  <app-table
                    [attrData]="attrDataComPerfilamiento"
                    [namesColumns]="namesColumnsComPerfilamiento"
                    [data]="cumplePerfilamiento"
                    [showPagination]="false"
                  ></app-table>
                </ng-container>
              </ng-template>

              <button
                class="btn btn-primary btn-icon w-80 mt-4"
                (click)="saveHealthQuest(modalContent)"
                [disabled]="
                  readonly || !puedeAvanzarPerfilamiento || !isAllHealthQuestsValid
                "
              >
                Siguiente
              </button>
            </div>
          </div>

          <div class="no-perfilamiento-container">
            <app-alert-message
              type="danger"
              message="NO CUMPLE perfilamiento"
            ></app-alert-message>
            <div class="p-4">
              <app-table
                [attrData]="attrDataNoPerfilamiento"
                [namesColumns]="namesColumnsNoPerfilamiento"
                [data]="noCumplePerfilamiento"
              ></app-table>
            </div>
          </div>
        </ng-container>
      </ng-template>
      <ng-template #tmplValidarAuditoria let-readonly="readonly">
        <div
          *ngIf="isLoadingAuditoria"
          class="d-flex flex-column justify-content-center align-items-center p-5 gap-3"
        >
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
          </div>
          <span class="text-muted">Validando auditoría...</span>
        </div>

        <ng-container *ngIf="!isLoadingAuditoria">
          <app-interfaz-auditoria
            [readonly]="readonly"
            [resultados]="resultadosInterfazAuditoria"
            [decisionInicial]="auditDecision"
            (anuladoExitoso)="resetAfterAnulacion()"
            (decisionCambio)="onDecisionAuditoria($event)"
            (continuarSiguiente)="onContinuarRadicacion()"
          ></app-interfaz-auditoria>
        </ng-container>
      </ng-template>
      <ng-template #tmplRadicarSolicitud>
        <!-- SARLAFT -->
        <div class="card mb-3 border-0">
          <div
            (click)="sarlaftColapsado = !sarlaftColapsado"
            style="cursor: pointer"
          >
            <app-info-alert title="Preguntas Sarlaft">
              Es importante hacer estas preguntas al contratante y
              asegurarte de que la información quede creada/actualizada en el sistema.
            </app-info-alert>
          </div>

          <div [hidden]="sarlaftColapsado">
            <div class="card-body">
              <app-preguntas-sarlaft
                (estadoValido)="onSarlaftEstado($event)"
              ></app-preguntas-sarlaft>
            </div>
          </div>
        </div>

        <!-- AUTORIZACIÓN -->
        <div class="card mb-3 border-0">
          <div
            (click)="autorizacionColapsado = !autorizacionColapsado"
            style="cursor: pointer"
          >
            <app-info-alert title="Autorización">
              Es importante hacer estas preguntas al contratante.
            </app-info-alert>
          </div>

          <div [hidden]="autorizacionColapsado">
            <div class="card-body">
              <app-autorizacion-radicacion
                (estadoValido)="onAutorizacionEstado($event)"
              ></app-autorizacion-radicacion>
            </div>
          </div>
        </div>

        <!-- SOPORTES -->
        <div class="card mb-3 border-0">
          <div
            (click)="soportesColapsado = !soportesColapsado"
            style="cursor: pointer"
          >
            <app-info-alert title="Soportes">
              Relacione los documentos requeridos para cada integrante
            </app-info-alert>
          </div>

          <div [hidden]="soportesColapsado">
            <div class="card-body">

              <!-- LOADER -->
              <div
                *ngIf="isLoadingSoportes"
                class="d-flex flex-column justify-content-center align-items-center p-5 gap-3"
              >
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Cargando...</span>
                </div>

                <span class="text-muted">
                  Consultando documentos requeridos...
                </span>
              </div>

              <!-- CONTENIDO -->
              <ng-container *ngIf="!isLoadingSoportes">

                <div class="row g-3 m-4 justify-content-start">
                  <div
                    *ngFor="let soporte of soportesDocumentales; let i = index"
                    class="col-12 col-md-6 col-lg-6"
                  >
                    <app-soporte-documentos-card
                      [nombrePersona]="soporte.nombreUsuario"
                      [identificacionUsuario]="soporte.identificacion"
                      [storageKey]="'soportes_' + i"
                      [documentosGenerales]="soporte.documentosGenerales"
                      [documentosEspecificos]="soporte.documentosEspecificos"
                      (estadoCompleto)="onSoporteEstado(i, $event)"
                      #soporteCard
                    >
                    </app-soporte-documentos-card>
                  </div>

                  <div
                    class="m-4"
                    *ngIf="soportesDocumentales.length === 0"
                  >
                    <p class="text-muted">
                      No hay soportes documentales para mostrar.
                    </p>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <button
          class="btn btn-primary mb-4 ms-4"
          *ngIf="mostrarBotonRadicarPendiente"
          [disabled]="isRadicando"
          (click)="radicarSolicitud('Radicado Pendiente por soporte')"
      >
        <span
          *ngIf="isRadicando"
          class="spinner-border spinner-border-sm me-2"
          role="status"
        ></span>
        Radicar con Pendiente Soportes
      </button>

      <button
        *ngIf="mostrarBotonPendienteFirma"
        class="btn btn-primary mb-4 ms-4"
        [disabled]="isRadicando"
        (click)="radicarSolicitud('Radicado Pendiente por firma')"
      >
        <span
          *ngIf="isRadicando"
          class="spinner-border spinner-border-sm me-2"
          role="status"
        ></span>
        Radicar Pendiente Firma
      </button>
      </ng-template>
      <ng-template #progressContent>
        <app-progress-bar
          [autoSimulate]="false"
          [steps]="pasosGeneracionDocumentos"
        ></app-progress-bar>
      </ng-template>
      <ng-template #contratoGenerado>
        <app-contracto-generado
          [solicitudNumero]="solicitudNumeroGenerada"
          [documentos]="documentosGeneradosSolicitud"
          [enlaceFirma]="enlaceFirmaGenerado"
          [errorEnlaceFirma]="errorEnlaceFirma"
        ></app-contracto-generado>
      </ng-template>

      <div ngbAccordion>
        <div
          ngbAccordionItem
          *ngFor="let item of items; let i = index; trackBy: trackByIndex"
          [collapsed]="item.collapsed"
          [disabled]="item.disabled"

        >
          <div ngbAccordionHeader>
            <button ngbAccordionButton>{{ item.title }}</button>
          </div>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody class="no-padding-body">
              <ng-container
                *ngTemplateOutlet="
                  item.template;
                  context: { readonly: item.readonly }
                "
              ></ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
